import { IonCol, IonRow } from '@ionic/react';

import { AttachmentAssetType, IAttachment } from '../../models/dms/attachment.model';
import { IonGridWrapper } from './VehicleAttachmentsGrid.styles';
import VehicleAttachment from '../vehicleAttachment/VehicleAttachment';

interface IComponentProps {
  assetType: AttachmentAssetType;
  assetKey: string;
  attachments: IAttachment[];
  handleClickAttachment?: (attachment: IAttachment) => void;
}

const VehicleAttachmentGrid: React.FC<IComponentProps> = ({ assetType, assetKey, attachments, handleClickAttachment }) => {
  return (
    <IonGridWrapper>
      <IonRow className="img-row">
        {attachments.map((attachment) => (
          <IonCol key={attachment.lineNumber + (attachment.fileName || '')} size="auto">
            <VehicleAttachment attachment={attachment} attachmentType={assetType} assetKey={assetKey} handleClick={() => handleClickAttachment?.(attachment)} />
          </IonCol>
        ))}
      </IonRow>
    </IonGridWrapper>
  );
};

export default VehicleAttachmentGrid;
